var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoEstrelaVazada01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico-estrela-2",
    d: "M7.5,35.5c-1,0-1.8-0.8-1.8-1.8c0-0.1,0-0.3,0-0.4l2.6-11.3L1,14.9c-0.7-0.7-0.7-1.8,0-2.5 c0.3-0.3,0.7-0.5,1.1-0.5l10-0.8l4.3-9.6c0.4-0.9,1.4-1.3,2.3-0.9c0.4,0.2,0.7,0.5,0.9,0.9l4.3,9.6l10,0.8c1,0.1,1.7,0.9,1.6,1.9 c0,0.4-0.2,0.9-0.6,1.2l-8,7.2l3.2,11.2c0.3,0.9-0.3,1.9-1.2,2.2c-0.5,0.1-1,0.1-1.5-0.2L18,28.9l-9.6,6.4 C8.2,35.4,7.8,35.5,7.5,35.5z M18,6.5l-3.2,7c-0.3,0.6-0.8,1-1.5,1l-7.2,0.6l5.3,5.2c0.4,0.4,0.6,1.1,0.5,1.7l-1.8,8l6.8-4.6 c0.6-0.4,1.4-0.4,1.9,0l6.5,4.4L23.3,22c-0.2-0.6,0-1.3,0.5-1.8l5.7-5.2l-7-0.6c-0.6-0.1-1.2-0.4-1.5-1L18,6.5L18,6.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEstrelaVazada01);
export default __webpack_public_path__ + "static/media/ico-estrela-vazada-01.688f96fa1cdadc3aeb5f57272d6b226a.svg";
export { ForwardRef as ReactComponent };